const mime = {
    'html' : 'text/html',
    'css'  : 'text/css',
    'jpg'  : 'image/jpg',
    'png'  : 'image/png',
    'ico'  : 'image/x-icon',
    'mp3'  : 'audio/mpeg3',
    'mp4'  : 'video/mp4',
    'csv'  : 'text/csv'
 };

/**
 * Obtiene el nombre de un archivo del final del valor
 * @param {String} value Valor de la cual extraer el nombre del archivo
 * @param {String} separador caracter por el cual se separará el valor para extraer el nombre
 */
export const getFileName = (value, separador = '/', withoutExtension = false) => {

    const lastIndex = value.split(separador).length - 1;    
    let fileName = value.split(separador)[lastIndex];

    if ( fileName.indexOf('?') >= 0 ) {

        fileName = fileName.split('?')[0];
    }

    return withoutExtension ? fileName.split('.')[0] : fileName;
}

/**
 * Obtiene el mimeType del archivo
 * @param {String} fileName Nombre del archivo con extensión incluida
 */
export const getMimeType = ( fileName ) => {

    const array = fileName.split('.');
    const extension = array[array.length - 1];

    return mime[extension];
};